import { ArrearsWidgetModule } from '@arrears-widget/arrears-widget.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@shared/shared.module';
import { InvoiceStatusModule } from '@feature/invoice-status/invoice-status.module';
import { PmaDocumentCentreModule } from '@feature/pma-document-centre/pma-document-centre.module';
import { AdditionalInformationWidgetModule } from '@feature/_app_modules/additional-information/additional-information-widget.module';
import { GridsterDashboardComponent } from
  '@feature/_app_modules/gridster-dashboard/container/gridster-dashboard/gridster-dashboard.component';
import { GridsterModule } from 'angular-gridster2';
import { DbwLayoutTestWidgetModule } from '@feature/_app_modules/dbw-layout-test-widget/dbw-layout-test-widget.module';
import { MojoDetailsWidgetModule } from '@feature/_app_modules/mojo-details-widget/mojo-details-widget.module';
import { MojoNotificationWidgetModule } from '@feature/_app_modules/mojo-notification-widget/mojo-notification-widget.module';
import { ArrearsListingWidgetModule } from '@feature/_app_modules/arrears-listing-widget/arrears-listing-widget.module';
import { DebtorAccountHistoryWidgetModule } from '@feature/_app_modules/debtor-account-history-widget/debtor-account-history-widget.module';
import { DebtBalancesDueWidgetModule } from '@feature/_app_modules/debt-balances-due-widget/debt-balances-due-widget.module';
import { NoticeBoardWidgetModule } from '../notice-board-widget/notice-board-widget.module';
import { CallsWidgetModule } from '../mojo-calls-widget/mojo-calls-widget.module';
import { InvoicesAndReceiptsWidgetModule } from '@feature/_app_modules/invoices-and-receipts-widget/invoices-and-receipts-widget.module';
import { RelatedContactsModule } from '../related-contacts/related-contacts.module';
import { BudgetVsActualModule } from '../budget-vs-actual/budget-vs-actual.module';

@NgModule({
  declarations: [
    GridsterDashboardComponent
    ],
  imports: [
    ArrearsWidgetModule,
    PmaDocumentCentreModule,
    CommonModule,
    SharedModule,
    GridsterModule,
    InvoiceStatusModule,
    AdditionalInformationWidgetModule,
    MojoDetailsWidgetModule,
    DbwLayoutTestWidgetModule,
    MojoNotificationWidgetModule,
    ArrearsListingWidgetModule,
    DebtBalancesDueWidgetModule,
    DebtorAccountHistoryWidgetModule,
    NoticeBoardWidgetModule,
    CallsWidgetModule,
    InvoicesAndReceiptsWidgetModule,
    RelatedContactsModule,
    BudgetVsActualModule
  ],
  exports: [
    GridsterDashboardComponent
    ]
})
export class GridsterDashboardModule { }
